module.exports = __webpack_public_path__ + "static/template-team-member-1-3cae2cc1530fbf778a232cfd1f11871a.jpg";